var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"area","height":"400","options":_vm.apexChatData.lineAreaChartSpline.chartOptions,"series":_vm.apexChatData.lineAreaChartSpline.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }